// phonics_data_lt19.js
// Letter Teams L19 - L19 Long Vowel Sounds oi, oy
// 路由：/phonics/lt19

const MEDIA_BASE = '/media/phonics/lt19';
const V = 'v1';

export const letterDataLt19 = {
  id: 'lt19',
  letter: 'L19',
  title: 'L19 Long Vowel Sounds oi, oy',
  mediaBase: MEDIA_BASE,

  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals see a boy.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "His name is Roy.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Roy sees a game.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "I want a toy.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "But I have no coins.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "That game looks fun.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "Green points to a coil.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
        { en: "Pink puts in a coin.", audioEn: `${MEDIA_BASE}/story1_8.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "He grabs the coil.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Yay!", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "Blue points to a toy pig.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Pink grabs the toy.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "Yay!", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Oink! Oink!", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Pink puts in lots of coins.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "He grabs lots of toys.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Pink has one coin left.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "He grabs a toy truck.", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "Let's give it to Roy!", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Roy jumps for joy.", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
      ],
    },
  ],
};
